import React, { useState, useRef } from "react";
import styles from "./MenuButtons.module.scss";
import AddToCollectionModal from "../AddToCollectionModal/AddtoCollectionModal";
import { useNavigate } from "react-router-dom";
import { Plus, Trash2, EyeOff, Eye } from "lucide-react";

interface MenuButtonsProps {
  handleHideClick: () => void;
  isStarClickLoading: boolean;
  className?: string;
  appId: number;
  isHidden?: boolean;
  isCollection?: boolean;
  isHiddenApps?: boolean;
  handleRemoveFromCollection?: (appId: number) => void;
  onClose?: () => void;
}

const MenuButtons: React.FC<MenuButtonsProps> = ({
  handleHideClick,
  isStarClickLoading,
  className,
  appId,
  isHidden,
  isCollection,
  isHiddenApps,
  handleRemoveFromCollection,
  onClose,
}) => {
  const navigate = useNavigate();
  const [isHideHovered, setIsHideHovered] = React.useState(false);
  const [showCollectionModal, setShowCollectionModal] = useState(false);

  const handleAddToCollectionClick = (e: React.MouseEvent) => {
    e.stopPropagation();

    // to change to use useMe
    const isUserLogin = localStorage.getItem("access_token");

    if (!isUserLogin) {
      navigate("/login");
      localStorage.setItem("btnName", "hide");
      return;
    }

    setShowCollectionModal(true);
  };

  if (showCollectionModal) {
    return (
      <AddToCollectionModal
        isOpen={showCollectionModal}
        onClose={() => {
          setShowCollectionModal(false);
          onClose?.();
        }}
        appId={appId}
      />
    );
  }

  return (
    <div className={`${styles.menuButtons} ${className}`}>
      <>
        <button
          onClick={handleAddToCollectionClick}
          className={styles.menuStarred}
          disabled={isStarClickLoading}
        >
          <div className={styles.menuHiddenIcon}>
            <Plus size={16} />
          </div>
          <p>Add App to Collection</p>
        </button>

        <button
          onClick={() =>
            isCollection || isHiddenApps
              ? handleRemoveFromCollection?.(appId)
              : handleHideClick()
          }
          className={styles.menuHidden}
          onMouseEnter={() => setIsHideHovered(true)}
          onMouseLeave={() => setIsHideHovered(false)}
        >
          <div className={styles.menuHiddenIcon}>
            {isCollection ? (
              <Trash2 size={16} className={styles.hide} />
            ) : isHidden ? (
              <EyeOff size={16} className={styles.hide} />
            ) : isHiddenApps ? (
              <EyeOff size={16} className={styles.hide} />
            ) : isHideHovered ? (
              <EyeOff size={16} className={styles.hide} />
            ) : (
              <Eye size={16} className={styles.hide} />
            )}
          </div>
          <p>
            {isCollection
              ? "Remove from Collection"
              : isHiddenApps
                ? "Unhide App"
                : isHidden
                  ? "Unhide App"
                  : "Hide App"}
          </p>
        </button>
      </>
    </div>
  );
};

export default MenuButtons;
